module.exports = __webpack_public_path__ + "static/media/arrow-right.ebf626b5.svg";